var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Contrats")]),_vm._v(" "),_vm._l((_vm.contracts),function(contract){return [_c(_vm.handleContractType(contract),{key:'customer-contract-'+contract.id,tag:"component",attrs:{"contract":_vm.prepareContract(contract)}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58792469","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Customer/InformationsContent/Contracts.vue
// module id = 1877
// module chunks = 0